<template>
  <div v-if="this.enableAccessAuthCreate('L1', this.getUser.pref.select.cauth)">
    <v-btn :color="ui.btnColor" flat dark @click="openDialog()"
    v-if="this.data.btnSize === 'flat'">
      <v-icon left>
        add
      </v-icon>
      New
    </v-btn>
    <v-btn :color="ui.bkgdColor" icon @click="openDialog()"
    v-else>
      <v-icon :color="ui.btnColor">
        add
      </v-icon>
    </v-btn>
    <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogLarge">
      <v-card :color="ui.bkgdColor">
        <v-card-title :class="ui.textTitle">
          <v-layout row>
            <v-icon large left :color="ui.btnColor"> add </v-icon>
            <span :class="ui.textHeadline">
              <div :class="ui.textColor">
                New Material
              </div>
            </span>
            <v-spacer/>
          </v-layout>
        </v-card-title>
        <v-progress-linear :color="ui.btnColor" height="1" value="100"/>
        <v-card-text :class="ui.bkgdColor">
          <v-layout class="text-xs-left ml-3 mr-2 mt-2">
            <div :class="ui.textSubheadingBold">
              {{stepInfo.title}}
            </div>
          </v-layout>
          <v-layout class="text-xs-left ml-3 mr-2 mt-2">
            <div :class="ui.textSubheading">
              {{stepInfo.msg}}
            </div>
          </v-layout>
          <v-form v-model="valid" lazy-validation>
            <v-container :class="ui.bkgdColor" v-if="this.step == 1">
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs11>
                  <v-text-field
                  v-model="localForm.name"
                  :rules="mustBeLessThanSmall"
                  prepend-icon="title"
                  hint="material name or title"
                  persistent-hint
                  required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs11>
                  <v-text-field
                  v-model="localForm.tag"
                  :rules="ruleMustBeNotUndefinedANDLessThan50"
                  prepend-icon="fingerprint"
                  hint="material id or tag"
                  persistent-hint
                  required
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>

            <v-container :class="ui.bkgdColor" v-if="this.step == 2">
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs11>
                  <v-text-field
                  v-model="localForm.itemPartOem"
                  :rules="ruleMustBeNotUndefinedANDLessThan50"
                  prepend-icon="storefront"
                  hint="manufaturer"
                  persistent-hint
                  required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs11>
                  <v-text-field
                  v-model="localForm.itemPartNum"
                  :rules="ruleMustBeNotUndefinedANDLessThan50"
                  prepend-icon="pin"
                  hint="part number"
                  persistent-hint
                  required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs11>
                  <v-select
                    v-model="localForm.dis"
                    :items="engineeringDiscipline"
                    color="wplblue0"
                    prepend-icon="engineering"
                    hint="discipline"
                    persistent-hint
                  >
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="ml-1 mr-1 mt-4">
                <v-flex xs10 offset-xs1>
                  <v-textarea
                  :color="ui.textColor"
                  :background-color="ui.btnColor"
                  v-model="localForm.des"
                  label="material description"
                  :disabled="false"
                  :outline="true"
                  :rules="ruleMustBeNotUndefinedANDLessThan2000"
                  hint="material requirements"
                  auto-grow
                  persistent-hint
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>

            <v-container :class="ui.bkgdColor" v-if="this.step == 3">
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> place </v-icon>
                  </v-avatar>
                  Facility
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{getUser.pref.select.fname}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> category </v-icon>
                  </v-avatar>
                  Name
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.name}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> category </v-icon>
                  </v-avatar>
                  {{localForm.name}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> fingerprint </v-icon>
                  </v-avatar>
                  Tag
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.tag}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> fingerprint </v-icon>
                  </v-avatar>
                  {{localForm.tag}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> place </v-icon>
                  </v-avatar>
                  Manufaturer
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.itemPartOem}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> place </v-icon>
                  </v-avatar>
                  {{localForm.itemPartOem}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> pin </v-icon>
                  </v-avatar>
                  Part
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.itemPartNum}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> pin </v-icon>
                  </v-avatar>
                  {{localForm.itemPartNum}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> engineering </v-icon>
                  </v-avatar>
                  Discipline
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.dis}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> engineering </v-icon>
                  </v-avatar>
                  {{localForm.dis}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> short_text </v-icon>
                  </v-avatar>
                  Description
                </v-chip>
                <v-spacer/>
              </v-layout>
              <v-layout class="text-xs-left ml-4 mr-2 mt-2">
                <div :class="ui.textSubheading">
                  {{localForm.des}}
                </div>
              </v-layout>
            </v-container>
          </v-form>

        </v-card-text>
          <v-card-actions>
            <v-btn
            @click="dialog = false" :color="ui.btnColor" flat>
              <v-icon left> exit_to_app </v-icon>
              Close
            </v-btn>
            <v-btn :disabled="!this.step > 0"
            class="hidden-xs-only"
            @click="previousStep(step)" :color="ui.btnColor" flat>
              <v-icon left> navigate_before </v-icon>
              Back
            </v-btn>
            <v-btn :disabled="!this.step > 0"
            class="hidden-sm-and-up"
            @click="previousStep(step)" :color="ui.btnColor" flat>
              <v-icon> navigate_before </v-icon>
            </v-btn>
            <v-spacer/>
            <v-btn :disabled="!valid" v-if="this.step < 4 && this.enableNextBtn"
            @click="nextStep(step)" :color="ui.btnColor" flat
            class="hidden-xs-only">
              Next
              <v-icon right> navigate_next </v-icon>
            </v-btn>
            <v-btn :disabled="!valid" v-if="this.step < 4 && this.enableNextBtn"
            @click="nextStep(step)" :color="ui.btnColor" flat
            class="hidden-sm-and-up"
            >
              <v-icon> navigate_next </v-icon>
            </v-btn>
            <v-btn :disabled="!valid"
            v-if="enableSubmit"
            class="hidden-xs-only"
            @click="createNewMaterial()" :color="ui.colorWarning" flat>
              <v-icon left> add </v-icon>
              Submit
            </v-btn>
            <v-btn :disabled="!valid"
            v-if="enableSubmit"
            class="hidden-sm-and-up"
            @click="createNewMaterial()" :color="ui.colorWarning" flat>
              <v-icon> add </v-icon>
            </v-btn>
            <BtnSpin :btnSpec="btnInfo1" v-if="btnSpinChangeDetail === true"/>
            </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import BtnSpin from "@/frame/animation/components/BtnSpin";
import storeFunctions from "@/data/functions/mixins/storeFunctions.js";
import ruleTextfield from "@/data/rules/mixins/rulesTextfield.js";
import facilityOptions from "@/data/options/mixins/facilityOptions.js";
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import changeDetail from "@/support/detail/mixins/changeDetail.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import createFirebase from "@/data/cloud/firebase/mixins/createFirebase.js";
import adminFunctions from "@/admin/functions/mixins/adminFunctions.js";
import generateForms from "@/data/functions/mixins/generateForms.js";
import generateID from "@/data/cloud/firebase/mixins/generateID.js";
import relationshipsFunctions from "@/data/functions/mixins/relationshipsFunctions.js";
import techOptions from "@/data/options/mixins/techOptions.js";
import moment from "moment";
import getData from "@/data/cloud/firebase/mixins/getData.js";
import accessFunctions from "@/support/access/mixins/accessFunctions.js";
import businessOptions from "@/data/options/mixins/businessOptions.js";
import { mapGetters } from "vuex";

export default {
  components: {
    BtnSpin
  },
  // eslint-disable-next-line
  mixins: [
    getData,
    apptheme,
    adminFunctions,
    docRevsModFunctions,
    createFirebase,
    ruleTextfield,
    facilityOptions,
    storeFunctions,
    changeDetail,
    relationshipsFunctions,
    generateID,
    generateForms,
    accessFunctions,
    techOptions,
    businessOptions
  ],
  props: {
    data: {
      type: Object
    }
  },
  data() {
    return {
      dialog: false,
      btnSpinChangeDetail: false,
      valid: true,
      btnInfo1: {
        color: "red",
        icon: "person",
        name: "add user"
      },
      indeterminateProgressBar: false,
      step: 0,
      localForm: {
        name: "",
        tag: "",
        des: "",
        dis: "",
        itemPartOem: "",
        itemPartNum: ""
      },
      info: [
        {
          step: 0,
          title: "Material",
          // eslint-disable-next-line
          msg: "Material is physical component which may be standalone warehouse component or part of asset bill of materials structure attached to the asset. Material includes essential information about material handling, storage and transport. If required material can be order to replenish store or for specific maintenance or project activity.",
          icon: ""
        },
        {
          step: 1,
          title: "Critical Material Info",
          // eslint-disable-next-line
          msg: "The material title and part id are key identifiers of materials. The description data may be different to original manufacturer or vendor part data.",
          icon: ""
        },
        {
          step: 2,
          title: "Basic Material Info",
          // eslint-disable-next-line
          msg: "Material manufacturer’s name and part numbers is the basic order and supplier information, which could be supplemented by technical discipline which defines material lifecycle ownership.",
          error: "",
          icon: ""
        },
        {
          step: 3,
          title: "Verify and Submit",
          // eslint-disable-next-line
          msg: "Verify entered information. If you need to edit then return to previous steps.",
          error: "",
          icon: ""
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["getUser"]),
    ui() {
      return this.uiTheme1;
    },
    stepInfo() {
      return this.info[this.step];
    },
    enableSubmit() {
      let logic = false;
      if (this.step === 3 && this.btnSpinChangeDetail === false) {
        logic = true;
      } else if (this.btnSpinChangeDetail === true) {
        logic = false;
      } else {
        logic = false;
      }
      return logic;
    },
    enableNextBtn() {
      let logic = false;
      if (this.step == 0) {
        logic = true;
      } else if (
        this.step == 1 &&
        this.localForm.name !== "" &&
        this.localForm.tag !== ""
      ) {
        logic = true;
      } else if (
        this.step == 2 &&
        this.localForm.itemPartOem !== "" &&
        this.localForm.itemPartNum !== ""
      ) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    }
  },
  methods: {
    nextStep(step) {
      this.step = step + 1;
    },
    previousStep(step) {
      this.step = step - 1;
    },
    openDialog() {
      this.dialog = true;
      this.step = 0;
      this.btnSpinReadResult = false;
    },
    closeDialog() {
      this.btnSpinReadResult = false;
    },
    createNewMaterial() {
      this.btnSpinChangeDetail = true;
      // SET data source
      const tag = "L1";
      const did = this.generateDID("DATE", tag);
      const idg = this.generateIDG("date-gid");

      // GENERATE form
      let temp = this.generateMaterialForm(); // form is from compnew component

      // BASIC
      temp.basic.did = did;
      temp.basic.idg = idg;
      temp.basic.tag = tag;
      temp.basic.act = false; // set asset to false
      temp.basic.title = this.localForm.name;
      temp.basic.id = this.localForm.tag;

      // CHAR
      temp.char.des = this.localForm.des;
      temp.char.make = this.localForm.itemPartOem;
      temp.char.npart = this.localForm.itemPartNum;
      temp.char.dis = this.localForm.dis;

      // STATS
      temp.stats.dcrt = moment().format();
      // eslint-disable-next-line
      temp.stats.drev = moment().add(4, 'years').format();

      // LINK data
      if (this.getUser.pref.select.fdid !== "") {
        temp.link.fid = this.getUser.pref.select.fdid;
        temp.link.ft = this.getUser.pref.select.fname;
        temp.link.fid = this.getUser.pref.select.fname;
      }

      // REV data
      temp.rev = this.generateInitialDocumentRev(tag);

      // Create Asset
      this.createFirebaseDocumentOnly(temp);

      // HELP
      console.log("NEW Material");
      console.log(temp);
    }
  }
};
</script>
